import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDropdown = (dropdown) => {
    if (openDropdown === dropdown) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(dropdown);
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <h2>Codes AI</h2>
            </Link>
          </div>
          
          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-menu">
              <li><Link to="/">Home</Link></li>
              
              <li className="dropdown">
                <Link to="/services" onClick={() => toggleDropdown('services')}>
                  Services <i className="fas fa-chevron-down"></i>
                </Link>
                <div className={`dropdown-content ${openDropdown === 'services' ? 'show' : ''}`}>
                  <div className="dropdown-section">
                    <h4>Team Augmentation</h4>
                    <Link to="/services/team-augmentation">Dedicated Team</Link>
                    <Link to="/services/team-augmentation">CTO as a Services</Link>
                    <Link to="/services/team-augmentation">Angular Development</Link>
                    <Link to="/services/team-augmentation">Java Development</Link>
                    <Link to="/services/team-augmentation">NET Development</Link>
                    <Link to="/services/team-augmentation">Node js Development</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>IT Consulting</h4>
                    <Link to="/services/it-consulting">Technology Consulting</Link>
                    <Link to="/services/it-consulting">Digital Transformation</Link>
                    <Link to="/services/it-consulting">Legacy Software Modernization</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Clouds</h4>
                    <Link to="/services/cloud-services">Cloud Consulting</Link>
                    <Link to="/services/cloud-services">Cloud Migration</Link>
                    <Link to="/services/cloud-services">SaaS</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>DevOps</h4>
                    <Link to="/services/devops">DevOps</Link>
                    <Link to="/services/devops">Kubernetes</Link>
                  </div>
                  <div className="dropdown-section">
                    <Link to="/services">Support & Maintenance</Link>
                  </div>
                </div>
              </li>

              <li className="dropdown">
                <Link to="/applications" onClick={() => toggleDropdown('applications')}>
                  Application's <i className="fas fa-chevron-down"></i>
                </Link>
                <div className={`dropdown-content ${openDropdown === 'applications' ? 'show' : ''}`}>
                  <div className="dropdown-section">
                    <Link to="/applications/website-development">Website Development</Link>
                    <Link to="/applications">Software Development</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Mobile Development</h4>
                    <Link to="/applications/mobile-development">App Development</Link>
                    <Link to="/applications/mobile-development">Android</Link>
                    <Link to="/applications/mobile-development">iOS</Link>
                    <Link to="/applications/mobile-development">Cross-Platform</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Game Development</h4>
                    <Link to="/applications/game-development">Game</Link>
                    <Link to="/applications/game-development">Augmented Reality</Link>
                    <Link to="/applications/game-development">Metaverse</Link>
                    <Link to="/applications/game-development">Virtual Reality</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Quality Assurance</h4>
                    <Link to="/applications/quality-assurance">Software Testing</Link>
                    <Link to="/applications/quality-assurance">Automation Testing</Link>
                    <Link to="/applications/quality-assurance">Manual Testing</Link>
                    <Link to="/applications/quality-assurance">Mobile Testing</Link>
                    <Link to="/applications/quality-assurance">Web Testing</Link>
                  </div>
                  <div className="dropdown-section">
                    <Link to="/applications/ui-ux-design">UI/UX Design</Link>
                    <Link to="/applications">Chatbot development</Link>
                  </div>
                </div>
              </li>

              <li className="dropdown">
                <Link to="/ai-data" onClick={() => toggleDropdown('ai-data')}>
                  AI & DATA <i className="fas fa-chevron-down"></i>
                </Link>
                <div className={`dropdown-content ${openDropdown === 'ai-data' ? 'show' : ''}`}>
                  <div className="dropdown-section">
                    <h4>Data Engineering</h4>
                    <Link to="/ai-data/data-engineering">Data Consulting</Link>
                    <Link to="/ai-data/data-engineering">Data Strategy</Link>
                    <Link to="/ai-data/data-engineering">Data Architecture</Link>
                    <Link to="/ai-data/data-engineering">Data Engineering</Link>
                    <Link to="/ai-data/data-engineering">Data Warehouse</Link>
                    <Link to="/ai-data/data-engineering">Enterprise Data Platform</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Analytics & BI</h4>
                    <Link to="/ai-data/analytics-bi">Data Analytics</Link>
                    <Link to="/ai-data/analytics-bi">Data Science</Link>
                    <Link to="/ai-data/analytics-bi">Data Visualization</Link>
                    <Link to="/ai-data/analytics-bi">Business Intelligence</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Data Management</h4>
                    <Link to="/ai-data">Data Integration</Link>
                    <Link to="/ai-data">Data Migration</Link>
                    <Link to="/ai-data">Data Management</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>AI</h4>
                    <Link to="/ai-data/ai-development">AI Consulting</Link>
                    <Link to="/ai-data/ai-development">AI Development</Link>
                    <Link to="/ai-data/ai-development">AI App Development</Link>
                    <Link to="/ai-data/ai-development">AI Proof of Concept</Link>
                    <Link to="/ai-data/ai-development">Computer Vision</Link>
                    <Link to="/ai-data/ai-development">Deep Learning</Link>
                    <Link to="/ai-data/ai-development">Machine Learning</Link>
                    <Link to="/ai-data/ai-development">Facial Recognition</Link>
                    <Link to="/ai-data/ai-development">Anomaly Detection</Link>
                    <Link to="/ai-data/ai-development">NLP</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Gen AI</h4>
                    <Link to="/ai-data/gen-ai">Gen AI Consulting</Link>
                    <Link to="/ai-data/gen-ai">Gen AI Development</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Blockchain</h4>
                    <Link to="/ai-data/blockchain">Smart Contract</Link>
                    <Link to="/ai-data/blockchain">Blockchain</Link>
                  </div>
                  <div className="dropdown-section">
                    <Link to="/ai-data/mlops">MLOps</Link>
                  </div>
                </div>
              </li>

              <li className="dropdown">
                <Link to="/engineering" onClick={() => toggleDropdown('engineering')}>
                  Engineering <i className="fas fa-chevron-down"></i>
                </Link>
                <div className={`dropdown-content ${openDropdown === 'engineering' ? 'show' : ''}`}>
                  <div className="dropdown-section">
                    <h4>Embedded</h4>
                    <Link to="/engineering/embedded-systems">Embedded Software</Link>
                    <Link to="/engineering/embedded-systems">Firmware Development</Link>
                    <Link to="/engineering/embedded-systems">HMI Development</Link>
                    <Link to="/engineering/embedded-systems">Middleware</Link>
                    <Link to="/engineering/embedded-systems">Wireless</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Internet of Things</h4>
                    <Link to="/engineering/iot-development">IoT Development</Link>
                    <Link to="/engineering/iot-development">Industrial IoT</Link>
                  </div>
                  <div className="dropdown-section">
                    <Link to="/engineering">Low-Code Development</Link>
                    <Link to="/engineering/mvp-development">MVP Development</Link>
                    <Link to="/engineering">Software Engineering</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Intelligent Automation</h4>
                    <Link to="/engineering">IPA</Link>
                    <Link to="/engineering">PRA</Link>
                  </div>
                  <div className="dropdown-section">
                    <Link to="/engineering/automotive">Automotive</Link>
                    <Link to="/engineering">Aerospace</Link>
                    <Link to="/engineering">Medical Equipment</Link>
                    <Link to="/engineering">Consumer Electronics</Link>
                    <Link to="/engineering">Embedded Foundation (EF™)</Link>
                    <Link to="/engineering">SysDesign™</Link>
                  </div>
                </div>
              </li>

              <li className="dropdown">
                <Link to="/industries" onClick={() => toggleDropdown('industries')}>
                  Industries <i className="fas fa-chevron-down"></i>
                </Link>
                <div className={`dropdown-content ${openDropdown === 'industries' ? 'show' : ''}`}>
                  <div className="dropdown-section">
                    <h4>Retail</h4>
                    <Link to="/industries/retail">Retail</Link>
                    <Link to="/industries/retail">AI for Retail</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Ecommerce</h4>
                    <Link to="/industries/ecommerce">Ecommerce Development</Link>
                    <Link to="/industries/ecommerce">Adobe Commerce</Link>
                  </div>
                  <div className="dropdown-section">
                    <Link to="/industries/fintech">FinTech</Link>
                    <Link to="/industries">Manufacturing & Supply Chain</Link>
                    <Link to="/industries">Logistics & Transportation</Link>
                    <Link to="/industries">Media & Entertainment</Link>
                  </div>
                  <div className="dropdown-section">
                    <h4>Healthcare & Biotech</h4>
                    <Link to="/industries/healthcare">Healthcare Software</Link>
                    <Link to="/industries/healthcare">AI for Healthcare</Link>
                    <Link to="/industries/healthcare">Biotech</Link>
                    <Link to="/industries/healthcare">Fitness & wellness</Link>
                    <Link to="/industries/healthcare">Life Science</Link>
                    <Link to="/industries/healthcare">Medical Imaging</Link>
                    <Link to="/industries/healthcare">Medical IoT</Link>
                    <Link to="/industries/healthcare">Mental Health App Development</Link>
                    <Link to="/industries/healthcare">mHealth</Link>
                    <Link to="/industries/healthcare">Pharma</Link>
                  </div>
                  <div className="dropdown-section">
                    <Link to="/industries">EdTech & eLearning</Link>
                    <Link to="/industries">Energy</Link>
                  </div>
                </div>
              </li>

              <li className="dropdown">
                <Link to="/about" onClick={() => toggleDropdown('company')}>
                  Company <i className="fas fa-chevron-down"></i>
                </Link>
                <div className={`dropdown-content ${openDropdown === 'company' ? 'show' : ''}`}>
                  <Link to="/about">About Us</Link>
                  <Link to="/blog">Blog</Link>
                  <Link to="/careers">Careers</Link>
                  <Link to="/about">How we work</Link>
                  <Link to="/about">Team</Link>
                  <Link to="/contact">Contact us</Link>
                </div>
              </li>
            </ul>
          </nav>

          <div className="header-actions">
            <div className="cart">
              <i className="fas fa-shopping-cart"></i>
              <span className="cart-count">0</span>
            </div>
            <Link to="/contact" className="btn btn-primary">Make Appointment</Link>
          </div>

          <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 